/**
 * @file 容器组件
 */

import {Component} from 'san';
import {debounce} from '../../utils/index';
import {DESIGN_WIDTH} from '../../common/const/index';
import {isMobile} from '../../utils/ua';
import pcHome from './components/pc-home';
import wiseHome from './components/wise-home';
import './app.less';

export default class App extends Component {
    static template = /* html */`
        <div class="page-index">
            <pc-home s-if="{{platform === 'pc'}}" root-font-size="{{rootFontSize}}" on-enterfullscreen="handleFullScreen"></pc-home>
            <wise-home s-else root-font-size="{{rootFontSize}}"></wise-home>
        </div>
    `;

    resizeHandler: any;

    static components = {
        'pc-home': pcHome,
        'wise-home': wiseHome,
    };

    initData() {
        return {
            platform: isMobile() ? 'wise' : 'pc',
            rootFontSize: 100,
            isFullScreen: false
        };
    }

    attached() {
        // 初始化数据
        this.handleResize();
        this.resizeHandler = debounce(this.handleResize.bind(this), 300);
        window.addEventListener('resize', this.resizeHandler);
    }

    detached(): void {
        window.removeEventListener('resize', this.resizeHandler);
        this.resizeHandler = null;
    }

    // 全屏
    handleFullScreen() {
        this.data.set('isFullScreen', true);
    }

    // 计算根字体大小
    calculateFontSize() {
        // 全屏时，不进行缩放
        if (this.data.get('isFullScreen') && !isMobile()) {
            return
        }

        const platform = this.data.get('platform');
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        if (platform === 'wise') {
            // 适配宽高比大于1的屏幕(折叠屏适配)
            if (screenWidth > screenHeight) {
                return 100 * screenHeight / screenWidth;
            }
            // 适配宽高比大于0.66的屏幕
            if ((screenWidth / screenHeight) >= 0.66) {
                return 100 * ((screenHeight / screenWidth) - 0.6);
            }
            // 宽高比小于0.66
            return 100;
        }

        const maxSize = 1;
        // 达到设计稿宽度的0.78倍（1400px）之后不被缩放
        const minSize = 0.78;
        const curSize = (screenWidth / DESIGN_WIDTH);
        const fontSize = (curSize > maxSize ? maxSize : curSize < minSize ? minSize : curSize) * 100;
        // 900以下屏幕高度需额外单独适配，继续缩放，缩放最小值为600
        if (screenHeight < 900) {
            return fontSize * (screenHeight <= 600 ? 600 : screenHeight) / 900;
        }
        return fontSize;
    }

    // 设置根字体大小
    setRootFontSiz() {
        const rootFontSize = this.calculateFontSize();
        this.data.set('rootFontSize', rootFontSize);
        document.documentElement.style.fontSize = rootFontSize + 'px';
    }

    // 窗口大小变化
    handleResize() {
        this.setRootFontSiz();
    }
}